import React, { useMemo, useState } from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import DenniNabidkaModal from "../denni_nabidka/denni-nabidka-modal.tsx";

const drinkSections = [
  {
    title: "Nealko nápoje",
    items: [
      "0,5/0,3 l – Točená Kofola originál",
      "0,25 l – RC Cola",
      "0,25 l – Vinea",
      "0,33 l – Voda perlivá / neperlivá",
      "0,25 l – Targa Tonic, Orange",
      "0,2 l – Džus Rauch (dle nabídky)",
      "0,5 l – Voda s mátou a citrónem",
      "0,5 l – Džus s vodou (Bazén)",
      "0,4 l – Domácí limonáda (dle nabídky)",
    ],
  },
  {
    title: "Káva a teplé nápoje",
    items: [
      "7 g – Turecká káva s mlékem",
      "7 g – Espresso + mléko",
      "7 g – Vídeňská káva",
      "7 g – Alžírská káva",
      "7 g – Capuccino",
      "7 g – Latte",
      "1 ks – Čaj s citronem",
      "0,5 l – Čaj z čerstvé máty",
      "0,5 l – Čaj z čerstvého zázvoru",
      "0,2 l – Svařák",
      "0,2 l – Grog",
      "0,2 l – Horký džus",
    ],
  },
  {
    title: "Pivo",
    items: [
      "0,5/0,3 l – Pivo 11°",
      "0,5 l – Nealkoholické pivo",
      "0,5/0,3 l – Radler ochucený",
      "0,5 l – Pivo plech",
    ],
  },
  {
    title: "Víno a aperitivy",
    items: [
      "0,2 l – Bílé víno",
      "0,2 l – Červené víno",
      "0,1 l – Martini, Cinzano",
      "0,1 l – Metropol",
      "0,75 l – Bohemia Sekt",
    ],
  },
  {
    title: "Alkoholické nápoje",
    items: [
      "0,04 l – Finlandia",
      "0,04 l – Fernet Stock",
      "0,04 l – Božkov Vodka, Rum",
      "0,04 l – Božkov Republika",
      "0,04 l – Bacardi, Tequila, Gin",
      "0,04 l – Slivovice",
      "0,04 l – Stará myslivecká",
      "0,04 l – Metaxa *****",
      "0,04 l – Jameson",
      "0,04 l – Tullamore",
      "0,04 l – Jack Daniels original / Honey",
      "0,04 l – Jägermaister",
      "0,04 l – Captain Morgan",
      "0,3 l – Aperol Spritz",
    ],
  },
];

const foodSections = [
  {
    title: "Předkrmy",
    items: [
      "220 g – Domácí libová tlačenka v patentní sklenici, chléb",
      "70 g – Domácí paštika, brusinky, chléb",
      "100 g – Domácí škvarková pomazánka, chléb",
      "150 g – Tataráček z mladého býčka z kašavského údolí (4 ks topinek)",
    ],
  },
  {
    title: "Polévky",
    items: [
      "0,5 l – Valašská kyselice s pravými hříbky a klobásou",
      "0,5 l – Hovězí vývar s kořenovou zeleninou, játrovým knedlíčkem a nudlemi",
    ],
  },
  {
    title: "Regionální speciality",
    items: [
      "300 g – Bramborové halušky s brynzou a domácím špekem",
      "300 g – Bramborové halušky se zelím a slaninou",
      "180 g – Smažená kuřecí prsíčka plněná tvarůžky a domácí slaninou",
    ],
  },
  {
    title: "Šéfkuchař doporučuje",
    items: [
      "400 g – Pomalu pečená vepřová žebírka na medu a černém pivu, chléb",
      "150 g – Myslivecký guláš na domácím špeku s cibulí (chléb / variace knedlíků)",
      "150 g – Svíčková na smetaně s brusinkami a šlehačkou (z oříšku mladého býčka, variace knedlíků)",
      "300 g – Konfitované kachní stehno, červené zelí s perníkem, skořicí, jablíčkem a medem, variace knedlíků",
      "400 g – Velký Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)",
    ],
  },
  {
    title: "Steaky",
    items: [
      "200 g – Filírovaná kuřecí prsíčka s bylinkovým pestem, parmezán",
      "200 g – Kuřecí prsíčka plněná mozzarelou a sušenými rajčaty",
      "150 g – Losos na grilu s bylinkovým pestem",
      "200 g – Steak z mladého býčka z kašavského údolí BIO dle nabídky",
      "200 g – Grilovaný prsní kuřecí steak",
      "200 g – Špalíček z vepřové panenky",
    ],
  },
  {
    title: "Oblíbená klasika",
    items: [
      "100 g – Smažený hermelín",
      "120 g – Smažený eidam",
      "150 g – Smažená kuřecí prsíčka",
      "200 g – Malý Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)",
    ],
  },
  {
    title: "Saláty",
    items: [
      "300 g – Caesar salát (filírované kuřecí prso se slaninou, krutony, parmezán, ledový salát)",
      "300 g – Šopský salát s balkánským sýrem",
      "300 g – Zeleninový salát s grilovaným hermelínem a dijonským přelivem",
    ],
  },
  {
    title: "Sladké menu",
    items: [
      "450 g – Valašský knedlík plněný borůvkami (se zakysanou smetanou a borůvkovým dipem)",
      "2 ks – Palačinky Paní nadlesní s perníkem, oříšky, medem, skořicí a šlehačkou",
      "2 ks – Palačinky s borůvkovou marmeládou, máslem a šlehačkou",
    ],
  },
  {
    title: "Přílohy",
    items: [
      "150 g – Hranolky",
      "200 g – Šťouchané brambory se slaninou a cibulí",
      "200 g – Vařené brambory s máslem a petrželkou",
      "200 g – Rozmarýnové brambory",
      "250 g – Grilovaná zelenina",
      "150 g – Restované fazolové lusky se slaninou",
      "200 g – Bramborový salát s majonézou",
    ],
  },
  {
    title: "Omáčky",
    items: [
      "0,1 l – Houbová",
      "0,1 l – Pepřová",
      "0,1 l – Kečup",
      "0,1 l – Tatarská omáčka",
    ],
  },
  {
    title: "Doplňkový prodej",
    items: [
      "1 ks – Chipsy",
      "1 ks – Tyčinky",
      "1 ks – Arašídy",
    ],
  },
];

// Stálý lístek (Po–Ne od 15 h) – přesně dle odpolední nabídky, bez cen.
const stalyFoodSections = [
  {
    title: "Předkrmy",
    items: [
      "220 g – Domácí libová tlačenka v patentní sklenici, chléb",
      "70 g – Domácí paštika, brusinky, chléb",
      "150 g – Tatarák z mladého býčka z kašavského údolí (4 ks topinek)",
    ],
  },
  {
    title: "Polévky",
    items: [
      "0,5 l – Valašská kyselice s pravými hříbky a klobásou",
      "0,5 l – Hovězí vývar s kořenovou zeleninou, játrovým knedlíčkem a nudlemi",
    ],
  },
  {
    title: "Hlavní chody",
    items: [
      "200 g – Špalíček z vepřové panenky",
      "200 g – Grilovaný prsní kuřecí steak",
      "200 g – Steak z mladého býčka z kašavského údolí BIO dle nabídky",
      "200 g – Filírovaná kuřecí prsíčka s bylinkovým pestem a parmezánem",
      "180 g – Kuřecí prsíčka plněná mozzarelou a sušenými rajčaty",
      "150 g – Smažená kuřecí prsíčka",
      "100 g – Smažený hermelín",
      "120 g – Smažený eidam",
      "180 g – Smažená kuřecí prsíčka plněná tvarůžky a domácí slaninou",
      "150 g – Myslivecký guláš, chléb, cibule",
      "400 g – Pomalu pečená vepřová žebírka na medu a černém pivu, chléb",
      "150 g – Losos na grilu s bylinkovým pestem",
      "200 g – Malý Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)",
      "400 g – Velký Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)",
      "450 g – Valašský knedlík (plněný borůvkami se zakysanou smetanou a borůvkovým dipem)",
    ],
  },
  {
    title: "Přílohy",
    items: [
      "150 g – Hranolky",
      "200 g – Vařené brambory s máslem a petrželkou",
      "200 g – Rozmarýnové brambory",
      "200 g – Bramborový salát s majonézou",
      "250 g – Grilovaná zelenina",
    ],
  },
  {
    title: "Omáčky",
    items: [
      "0,1 l – Houbová",
      "0,1 l – Pepřová",
      "0,1 l – Kečup",
      "0,1 l – Tatarská omáčka",
    ],
  },
];

type MenuId = "denni" | "zuzeny" | "dlouhy";

type MenuTab = {
  id: MenuId;
  label: string;
  platnostDny: string;
  platnostCas: string;
  // Vrací true, pokud toto menu právě teď platí (den + hodina).
  jeAktivni: (den: number, hodina: number) => boolean;
};

const MENU_TABS: MenuTab[] = [
  {
    id: "denni",
    label: "Denní menu",
    platnostDny: "Po–Pá",
    platnostCas: "11–15 h",
    jeAktivni: (den, hodina) => den >= 1 && den <= 5 && hodina >= 11 && hodina < 15,
  },
  {
    id: "zuzeny",
    label: "Odpolední nabídka",
    platnostDny: "Po–Ne",
    platnostCas: "od 15 h",
    jeAktivni: (_den, hodina) => hodina >= 15,
  },
  {
    id: "dlouhy",
    label: "Velký lístek",
    platnostDny: "So–Ne",
    platnostCas: "11–15 h",
    jeAktivni: (den, hodina) => (den === 6 || den === 0) && hodina >= 11 && hodina < 15,
  },
];

type Section = { title: string; items: string[] };

const SectionList: React.FC<{ section: Section }> = ({ section }) => (
  <div>
    <h3 className="text-xl font-serif font-semibold mb-3 inline-block border-b-2 border-[#60260F] pb-1">
      {section.title}
    </h3>
    <ul className="space-y-2 leading-relaxed">
      {section.items.map((item) => (
        <li key={item} className="border-b border-[#d8c4a3] pb-2">
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const FoodGrid: React.FC<{ sections: Section[] }> = ({ sections }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 items-start">
    {sections.map((section) => (
      <SectionList key={section.title} section={section} />
    ))}
  </div>
);

const Napoje: React.FC = () => (
  <div className="mt-16 pt-10 border-t-2 border-[#60260F]/30">
    <h2 className="text-2xl md:text-3xl font-serif font-bold mb-8 text-[#60260F] inline-block border-b-4 border-[#60260F] pb-2">
      Nápojový lístek
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 items-start">
      {drinkSections.map((section) => (
        <SectionList key={section.title} section={section} />
      ))}
    </div>
  </div>
);

const JidelniListek: React.FC = () => {
  const aktivniId = useMemo<MenuId | null>(() => {
    const now = new Date();
    const den = now.getDay();
    const hodina = now.getHours();
    return MENU_TABS.find((tab) => tab.jeAktivni(den, hodina))?.id ?? null;
  }, []);

  const [activeTab, setActiveTab] = useState<MenuId>(aktivniId ?? "denni");
  const active = MENU_TABS.find((tab) => tab.id === activeTab)!;
  const [denniOpen, setDenniOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>Jídelní lístek | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Aktuální jídelní a nápojový lístek Hospůdky pod Rablinů včetně příloh a doplňkového prodeje."
        />
      </Helmet>

      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">
        <section className="bg-white text-center py-16 px-6">
          <h1 className="text-2xl md:text-4xl font-bold font-serif">
            JÍDELNÍ A NÁPOJOVÝ LÍSTEK
          </h1>
        </section>

        {/* Přepínač menu */}
        <section className="max-w-5xl mx-auto px-6 pt-12">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {MENU_TABS.map((tab) => {
              const isActive = tab.id === activeTab;
              const jeTedVNabidce = tab.id === aktivniId;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  aria-pressed={isActive}
                  className={`
                    relative h-full text-left rounded-2xl px-5 pb-5 pt-12 border-2 transition
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-[#60260F]
                    ${
                      isActive
                        ? "bg-[#60260F] text-white border-[#60260F] shadow-lg -translate-y-0.5"
                        : "bg-white/70 text-[#32180d] border-transparent hover:border-[#60260F]/40 hover:bg-white"
                    }
                  `}
                >
                  {jeTedVNabidce ? (
                    <span
                      className={`
                        absolute top-4 left-5 inline-block text-[11px] font-semibold uppercase tracking-wide
                        px-2 py-0.5 rounded-full
                        ${isActive ? "bg-white text-[#60260F]" : "bg-[#60260F] text-white"}
                      `}
                    >
                      Právě v nabídce
                    </span>
                  ) : null}
                  <div className="font-serif font-bold text-lg md:text-xl">{tab.label}</div>
                  <div
                    className={`mt-2 text-sm font-semibold ${
                      isActive ? "text-white/90" : "text-[#60260F]"
                    }`}
                  >
                    {tab.platnostDny} · {tab.platnostCas}
                  </div>
                </button>
              );
            })}
          </div>
        </section>

        {/* Obsah zvoleného menu */}
        <section className="max-w-5xl mx-auto px-6 py-14">
          <div className="bg-white/60 rounded-3xl p-6 md:p-10 shadow-sm">
            <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-8">
              <h2 className="text-2xl md:text-3xl font-serif font-bold inline-block border-b-4 border-[#60260F] pb-2">{active.label}</h2>
              <span className="text-[#60260F] font-semibold">
                {active.platnostDny} · {active.platnostCas}
              </span>
            </div>

            {activeTab === "denni" ? (
              <div>
                <button
                  type="button"
                  onClick={() => setDenniOpen(true)}
                  className="inline-block px-6 py-3 bg-[#60260F] text-white font-serif rounded-xl hover:bg-[#7a3419] transition"
                >
                  Otevřít denní nabídku
                </button>
              </div>
            ) : (
              <FoodGrid sections={activeTab === "zuzeny" ? stalyFoodSections : foodSections} />
            )}

            {/* Nápoje jsou součástí každého menu */}
            <Napoje />
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-6 pb-12">
          <div className="bg-white/70 rounded-2xl p-6 md:p-8 shadow-sm">
            <p className="text-lg font-serif mb-3">Platnost od 1. dubna 2026</p>
            <p className="leading-relaxed">
              Při poloviční porci účtujeme 70 % z ceny. Informace o alergenech obsažených
              v pokrmech jsou k nahlédnutí u obsluhy. Děkujeme za pochopení.
            </p>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-6 pb-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            "./img/jidelni-listek/salat.jpg",
            "./img/jidelni-listek/kolacky-1.jpg",
            "./img/jidelni-listek/maso-1.jpg",
            "./img/jidelni-listek/bagety-1.jpg",
            "./img/jidelni-listek/maso-stul-1.jpg",
            "./img/jidelni-listek/maso-2.jpg",
          ].map((src, i) => (
            <img
              key={i}
              src={src}
              alt="Jídlo z nabídky Hospůdky pod Rablinů"
              className="w-full h-64 object-cover rounded-xl shadow"
            />
          ))}
        </section>

        <div className="[all:unset] block">
          <Footer />
        </div>
      </main>

      <DenniNabidkaModal open={denniOpen} onClose={() => setDenniOpen(false)} />
    </>
  );
};

export default JidelniListek;
